import React from 'react';

const DoctorIcon = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.35,5.88A2.62,2.62,0,0,0,16.66,11v2.39a5.26,5.26,0,0,1-5.19,5.19,5.26,5.26,0,0,1-5.19-5.19v-.31a5.66,5.66,0,0,0,4.9-5.57V.69A.72.72,0,0,0,11,.19a.72.72,0,0,0-.5-.19h-2A.72.72,0,0,0,8,.19a.74.74,0,0,0-.19.5.72.72,0,0,0,.19.5.72.72,0,0,0,.5.19H9.8V7.55a4.21,4.21,0,0,1-8.42,0V1.38H2.65a.72.72,0,0,0,.5-.19.72.72,0,0,0,.19-.5.74.74,0,0,0-.19-.5A.72.72,0,0,0,2.65,0h-2a.74.74,0,0,0-.5.19A.72.72,0,0,0,0,.69V7.55a5.66,5.66,0,0,0,4.9,5.57v.31a6.57,6.57,0,0,0,13.14,0V11a2.62,2.62,0,0,0-.69-5.16Zm0,1.38a1.27,1.27,0,1,1-1.27,1.27A1.3,1.3,0,0,1,17.35,7.26Z" />
  </svg>
);

export default DoctorIcon;
